<template>
  <validation-provider :vid="vid"
    :name="$attrs.label"
    :rules="rules"
    #default="slotProps"
  >
    <a-form-item
      :label="$attrs.label"
      :validate-status="resolveState(slotProps)"
      :help="slotProps.errors[0]"
    >
      <base-input
        :type="$attrs.type"
        :placeholder="$attrs.placeholder || '请输入'"
        v-model="modelValue"
      />
    </a-form-item>
  </validation-provider>
</template>

<script>
import { computed } from '@vue/composition-api'
import { resolveState } from '@/utils/tools'

export default {
  name: 'InputWithValidation',
  components: {
    'base-input': {
      render (h, context) {
        const self = this
        return h('a-input', {
          attrs: self.$attrs,
          on: {
            change (event) {
              self.$emit('input', event.target.value)
            },
            blur () {
              self.$emit('blur')
            }
          }
        })
      }
    }
  },
  props: {
    vid: String,
    rules: {
      type: [Object, String],
      default: ''
    },
    value: null
  },
  emits: ['input', 'blur'],
  setup (props, { emit }) {
    const modelValue = computed({
      get: () => props.value,
      set: value => {
        emit('input', value)
      }
    })
    return {
      modelValue,
      resolveState
    }
  }
}
</script>
